import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import PropTypes from 'prop-types'

import RegisterResponsiblesDialog from '../RegisterResponsiblesDialog'

const RegisterResponsiblesButton = ({ category, onRefresh }) => {
  const [open, setOpen] = useState(false)

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button color="secondary" onClick={handleClick} fullWidth size="small">
        Registrar Responsáveis
      </Button>
      <RegisterResponsiblesDialog
        open={open}
        onClose={handleClose}
        category={category}
        onRefresh={onRefresh}
      />
    </>
  )
}

RegisterResponsiblesButton.propTypes = {
  category: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
}

export default RegisterResponsiblesButton
